module.exports = __webpack_public_path__ + "img/logo.e7f6ee40.png";